
const TemplateLoader = () => {

	return <iframe style={{width:'100%', height:'100%'}} src={'templates/index.html'}></iframe>  
}

export default TemplateLoader;